import _ from 'lodash'
import * as query from '@/queries/order'
import utils from '@/store/utils'

const defaultState = function () {
  return {
    mode: 0, // 0: 通常, 1: 注文編集, 2: 交換出荷, 3: 返品登録
    returnList: false, // オペレーションボタンから編集モードに遷移したか
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'order_list',
    maxGetCount: null,
    // 検索条件
    searchConditions: {},
    // 表示項目
    displayItems: []
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    orderStatus () {
    },
    orderStatuses () {
    },
    orderStatusesByOrderId () {
    }
  },
  mutations: {
    update (state, data) {
      const rowData = utils.pick(data, utils.createKeys(query.GRAPH_QL_QUERY_ORDER_LIST, 3))
      _.chain(state.tdLists)
        .filter((value) => value.node.site.code === data.site.code && value.node.orderNo === data.orderNo)
        .forEach((val) => { val.node = rowData })
        .value()
    },
    /**
     * O-Pluxイベント更新APIの結果をリストに反映する
     * - uuid
     * - lsUpAt 最終更新日時
     * - rBody リクエスト(反映内容)
     * - kMap キーマップ
     */
    updateOpluxData (state, { uuid, lsUpAt, rBody, kMap }) {
      if (state.tdLists.length === 0) return
      _.chain(state.tdLists)
        // 対象行の取得
        .find(v => v.node.uuid === uuid)
        .tap(v => {
          // 最終更新日時の反映
          v.node.lastUpdatedAt = lsUpAt
          // 属性情報の反映
          Object.keys(rBody).forEach(k => {
            // リクエストキーに対応する属性キーを取得
            const attrId = _.find(kMap, { request: k }).attr
            const attrValue = rBody[k]
            // 変更前データの属性情報を取得
            const originAttr = _.find(v.node.attributes, { attrId: attrId })
            if (originAttr) {
            // 変更前に存在する場合、更新
              originAttr.attrValue = attrValue
            } else {
            // 存在しない場合、追加
              v.node.attributes.push({
                attrId: attrId,
                attrValue: attrValue
              })
            }
          })
        })
        .value()
    }
  },
  getDefaultState: defaultState
}
